import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Shield, Lock, Eye, FileText, UserCheck, Trash2 } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Privacy = () => {
  const { language } = useLanguage();
  const it = language === 'it';

  const sections = [
    {
      icon: FileText,
      title: it ? 'Informativa sulla Privacy' : 'Privacy Policy',
      content: it
        ? 'La presente informativa descrive le modalità di trattamento dei dati personali degli utenti che utilizzano la piattaforma Moneyfor, in conformità al Regolamento UE 2016/679 (GDPR) e alla normativa italiana in materia di protezione dei dati personali.'
        : 'This privacy policy describes how personal data of users who use the Moneyfor platform is processed, in compliance with EU Regulation 2016/679 (GDPR).'
    },
    {
      icon: UserCheck,
      title: it ? 'Titolare del trattamento' : 'Data Controller',
      content: it
        ? 'Il titolare del trattamento dei dati è Moneyfor, raggiungibile all\'indirizzo email postmaster@moneyfor.it. Per qualsiasi richiesta relativa al trattamento dei dati personali, è possibile contattarci a tale indirizzo.'
        : 'The data controller is Moneyfor, reachable at postmaster@moneyfor.it.'
    },
    {
      icon: Eye,
      title: it ? 'Dati raccolti' : 'Data Collected',
      content: it
        ? 'Raccogliamo i seguenti dati: nome, email, password (crittografata), foto profilo, età, sesso, città di residenza, numero di telefono, indirizzo PayPal, dati bancari IBAN, tipo di utente (donatore/richiedente/azienda). Per le donazioni: importi, metodo di pagamento, data. Per la chat: messaggi, foto e video scambiati. Per il Mercatino Solidale: annunci, foto, descrizioni, città. Dati tecnici: indirizzo IP, tipo di browser, dati di navigazione.'
        : 'We collect: name, email, encrypted password, profile photo, age, gender, city, phone number, PayPal address, bank details, user type. For donations: amounts, payment method, date. For chat: messages, photos, videos. For Marketplace: listings, photos, descriptions, city. Technical: IP address, browser type, navigation data.'
    },
    {
      icon: Shield,
      title: it ? 'Finalità del trattamento' : 'Purpose of Processing',
      content: it
        ? 'I dati vengono trattati per: (a) erogazione del servizio di donazione e marketplace, (b) gestione dell\'account utente, (c) comunicazioni relative al servizio (notifiche, messaggi), (d) prevenzione frodi e moderazione dei contenuti, (e) adempimenti di legge. I dati non vengono ceduti a terzi per finalità commerciali.'
        : 'Data is processed for: (a) providing donation and marketplace services, (b) user account management, (c) service-related communications, (d) fraud prevention and content moderation, (e) legal obligations. Data is not shared with third parties for commercial purposes.'
    },
    {
      icon: Lock,
      title: it ? 'Sicurezza e conservazione' : 'Security and Retention',
      content: it
        ? 'I dati sono protetti mediante crittografia (password con bcrypt, comunicazioni HTTPS, token JWT). I dati vengono conservati per il tempo necessario alle finalità del trattamento e comunque non oltre 5 anni dalla cancellazione dell\'account. I dati delle transazioni vengono conservati per 10 anni per obblighi fiscali.'
        : 'Data is protected through encryption (passwords with bcrypt, HTTPS communications, JWT tokens). Data is retained for the time necessary for processing purposes and no longer than 5 years after account deletion. Transaction data is retained for 10 years for tax obligations.'
    },
    {
      icon: Trash2,
      title: it ? 'Diritti dell\'interessato' : 'User Rights',
      content: it
        ? 'In base al GDPR, hai diritto di: accedere ai tuoi dati personali, rettificarli, cancellarli (diritto all\'oblio), limitare il trattamento, opporti al trattamento, richiedere la portabilità dei dati. Per esercitare i tuoi diritti, scrivi a postmaster@moneyfor.it. Hai inoltre il diritto di presentare reclamo al Garante per la Protezione dei Dati Personali.'
        : 'Under GDPR, you have the right to: access your personal data, rectify it, delete it (right to be forgotten), restrict processing, object to processing, request data portability. To exercise your rights, write to postmaster@moneyfor.it.'
    }
  ];

  return (
    <div className="min-h-screen bg-stone-100 overflow-y-auto">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="privacy-page">
        <div className="bg-gradient-to-br from-emerald-800 to-emerald-900 rounded-3xl p-8 md:p-12 mb-10 text-white">
          <Shield className="h-10 w-10 mb-4 text-emerald-300" />
          <h1 className="font-heading text-3xl md:text-4xl font-bold mb-3">
            {it ? 'Privacy e Trattamento Dati' : 'Privacy & Data Processing'}
          </h1>
          <p className="text-emerald-200 text-lg">
            {it ? 'Ultimo aggiornamento: Aprile 2026' : 'Last updated: April 2026'}
          </p>
        </div>

        <div className="space-y-6">
          {sections.map((section) => (
            <div key={section.title} className="bg-white rounded-2xl shadow-sm border border-stone-200 p-6 md:p-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center shrink-0">
                  <section.icon className="h-5 w-5 text-emerald-700" />
                </div>
                <div>
                  <h2 className="font-heading text-lg font-semibold text-stone-900 mb-2">{section.title}</h2>
                  <p className="text-stone-600 leading-relaxed">{section.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center text-sm text-stone-500">
          <p>{it ? 'Per qualsiasi domanda:' : 'For any questions:'} <a href="mailto:postmaster@moneyfor.it" className="text-emerald-700 hover:underline">postmaster@moneyfor.it</a></p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
